import TabNav from 'components/TabNav/TabNav';
import { selectCurrentUser } from 'ducks/user.duck';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  PARENT_USER_TYPE,
  PROVIDER_USER_TYPE,
} from '../../../extensions/account-settings/config/users';

import css from './LayoutSideNavigation.module.css';

const TabNavByUserType = ({ currentPage }) => {
  const currentUser = useSelector(selectCurrentUser);
  const userType = currentUser?.attributes.profile.publicData.userType;
  const tabs = useMemo(() => {
    const generalTabs = [
      {
        text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.contactDetailsTabTitle" />,
        selected: currentPage === 'ContactDetailsPage',
        id: 'ContactDetailsPageTab',
        linkProps: {
          name: 'ContactDetailsPage',
        },
      },
      {
        text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.passwordTabTitle" />,
        selected: currentPage === 'PasswordChangePage',
        id: 'PasswordChangePageTab',
        linkProps: {
          name: 'PasswordChangePage',
        },
      },
    ];
    const paymentTab = {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentMethodsTabTitle" />,
      selected: currentPage === 'PaymentMethodsPage',
      id: 'PaymentMethodsPageTab',
      linkProps: {
        name: 'PaymentMethodsPage',
      },
    };
    const payoutTab = {
      text: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentsTabTitle" />,
      selected: currentPage === 'StripePayoutPage',
      id: 'StripePayoutPageTab',
      linkProps: {
        name: 'StripePayoutPage',
      },
    };

    if (userType === PARENT_USER_TYPE) {
      return [...generalTabs, paymentTab];
    }
    if (userType === PROVIDER_USER_TYPE) {
      return generalTabs;
    }
    return [...generalTabs, payoutTab, paymentTab];
  }, [currentPage]);

  return <TabNav rootClassName={css.tabs} tabRootClassName={css.tab} tabs={tabs} />;
};

export default TabNavByUserType;
